import { clsx } from 'clsx';
import { FC, useMemo, useState } from 'react';
import styles from './styles.module.css';

export const ProgressBar: FC<{
  value: number;
}> = ({ value }) => {
  const [colorClass, setColorClass] = useState<string>('');
  const width = useMemo(() => {
    if (value <= 40) {
      setColorClass(styles.strengthBad);
    } else if (value > 40 && value <= 75) {
      setColorClass(styles.strengthNormal);
    } else if (value > 75) {
      setColorClass(styles.strengthGood);
    }

    return value;
  }, [value]);

  return (
    <div className={styles.progressBar}>
      <div
        className={clsx(styles.line, colorClass)}
        style={{ width: `${width}%` }}
      />
    </div>
  );
};
